<template>
	<div class="display-flex justify-content-center align-items-center height-100">
		<article class="login-info-space display-flex-smo flex-direction-column-reverse-smo col-12-smo">
			<img
				class="align-self-center img-native-width"
				:src="adSpaceContent.img.src"
				:alt="adSpaceContent.img.alt"
			/>
			<div class="mb-150-smo p-100-smo mt-300-md">
				<p
					v-if="adSpaceContent.preheader"
					class="label-sm text-color-brand-primary text-transform-uppercase mb-50"
				>
					{{ adSpaceContent.preheader }}
				</p>
				<div class="text-color-white">
					<p class="heading-2">{{ adSpaceContent.headline }}</p>
					<p class="body-sm mt-50">{{ adSpaceContent.body }}</p>
				</div>
			</div>
		</article>
	</div>
</template>
<script setup lang="ts">
import { AdSpaceContent } from 'types/ad-space';

interface Props {
	adSpaceContent: AdSpaceContent;
}

defineProps<Props>();
</script>
<style lang="scss" scoped>
@use '../../styles/utilities/respond-to.scss' as *;

@include respond-to(lg) {
	.login-info-space {
		max-width: 336px;
	}
}
</style>
